import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import LazyImage from '../../../Layouts/LazyImage';
import Typography18 from '../../../Layouts/MaterialUi/Typography18';

const WhatWeDoItems = ({ data }) => {
  return (
    <div>
      <Box minHeight="125px" maxWidth={'200px'} margin="auto" px={5} mb={2}>
        <LazyImage quality={85} sizes={sizes} src={data?.img} />
      </Box>
      <Typography18>
        {data?.title[0]}{' '}
        <Typography variant="subtitle1" component="i" color={'#7F56D9'}>
          <b>{data?.title[1]}</b>
        </Typography>
      </Typography18>
    </div>
  );
};
const sizes = {
  xxl: [120, 120],
};

export default WhatWeDoItems;
